import * as XLSX from 'xlsx';

export class ExcelReader {
  static async readFile<T>(file: File, options?: XLSX.Sheet2JSONOpts) {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, {type: 'array', cellDates: true});
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    return XLSX.utils.sheet_to_json<T>(worksheet, options);
  }
}